import { IBounds } from '@umu/umu-types';

export default function getElementBounds(element: HTMLElement): IBounds {
    if (!element) {
        return element;
    }
    const rect = element.getBoundingClientRect();
    return {
        left: window.pageXOffset + rect.left,
        right: window.pageXOffset + rect.left + rect.width,
        top: window.pageYOffset + rect.top,
        bottom: window.pageYOffset + rect.top + rect.height,
    };
}
